import {
  COMPONENT_VALUE_TYPES as types,
  COMPONENT_COLOR_THEMES,
  THREE_POSITION_LAYOUTS,
  FONT_FAMILIES,
  FONT_COLORS,
  FONT_SIZES,
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

const propsSchema = [
  {
    key: 'tabs',
    label: 'Tabs',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Tab Title',
        type: types.TEXT
      },
      {
        key: 'defaultTab',
        label: 'Default Tab',
        type: types.BOOLEAN
      },
    ]
  },
  {
    key: 'color',
    label: 'Tab Color',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'tabStyle',
    label: 'Tab Style',
    type: types.OBJECT,
    children: [
      {
        key: 'position',
        label: 'Position (left/central/right)',
        type: types.ENUM,
        options: THREE_POSITION_LAYOUTS
      },
      {
        key: 'font_family',
        label: 'Font Family',
        type: types.ENUM,
        options: FONT_FAMILIES
      },
      {
        key: 'font_color',
        label: 'Font Color',
        type: types.ENUM,
        options: FONT_COLORS
      },
      {
        key: 'font_size',
        label: 'Font Size',
        type: types.ENUM,
        options: FONT_SIZES
      },
    ]
  },
];

const defaultProps = {
  tabs: [
    { title: 'Past Event', defaultTab: false },
    { title: 'Current Event', defaultTab: true },
    { title: 'Future Event', defaultTab: false }
  ],
  color: 'LIGHT',
  tabStyle: {
    position: 'CENTRAL',
    font_family: FONT_FAMILY_ROBOTO,
    font_color: 'Dark',
    font_size: '14',
  }
};

export default {
  title: 'Tab Menu',
  id: 'TabMenu',
  widgetImage: `/widgetImages/Tab+Widget+Icon.png`,
  basic: true,
  propsSchema,
  defaultProps
};
